import Vue from 'vue'
import Router from 'vue-router'

import Home from "../views/Home"
import About from "../views/About"
import Contact from "../views/Contact"
import Service from "../views/Service"
import Solution from "../views/Solution"
import NotFound from '../views/NotFound'
import CaseDisplay from '../views/CaseDisplay'
Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: '/',
      redirect:'home'
    },
    {
      path: '/home',
      name: '主页',
      component: Home,
      meta: {
        title: '主页'
      }
    },
    {
      path: '/about',
      name: '关于我们',
      component: About,
      meta: {
        title: '关于我们'
      }
    },
    {
      path: '/service',
      name: '服务',
      component: Service,
      meta: {
        title: '服务'
      }
    },
    {
      path: '/solution',
      name: '解决方案',
      component: Solution,
      meta: {
        title: '解放方案'
      }
    },
    {
      path: '/contact',
      name: '联系',
      component: Contact,
      meta: {
        title: '联系'
      }
    },
    {
      path: '/CaseDisplay',
      name: '案例展示',
      component: CaseDisplay
    },
    {
      path: '*',
      name: '找不到页面',
      component: NotFound
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js